// Configuration des modules disponibles dans l'application
export const MODULES_CONFIG = [
  {
    id: 'DN_VIEWER',
    name: 'Distribution Numérique',
    description: 'Analysez la distribution et disponibilité de vos produits en magasin.',
    path: '/dn-viewer',
    icon: (
      <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    colors: {
      bg: 'bg-blue-100 dark:bg-blue-900/30',
      text: 'text-blue-600 dark:text-blue-400',
      border: 'border-gray-200 dark:border-gray-700'
    },
    displayCondition: (user) => {
      return user?.bi_modules?.allowed?.includes('DN_VIEWER') ||
             user?.bi_modules?.allowed?.includes('*') ||
             user?.issuperadmin;
    }
  },
  {
    id: 'VISITS_VIEWER',
    name: 'Visites Magasins',
    description: 'Suivez les visites en magasin effectuées par vos équipes terrain.',
    path: '/visits-viewer',
    icon: (
      <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
    colors: {
      bg: 'bg-purple-100 dark:bg-purple-900/30',
      text: 'text-purple-600 dark:text-purple-400',
      border: 'border-gray-200 dark:border-gray-700'
    },
    displayCondition: (user) => {
      return user?.bi_modules?.allowed?.includes('VISITS_VIEWER') ||
             user?.bi_modules?.allowed?.includes('*') ||
             user?.issuperadmin;
    }
  },
  {
    id: 'GI_CAMPAIGNS_VIEWER',
    name: 'Campagnes GI',
    description: 'Consultez les données des campagnes de vos équipes terrain.',
    path: '/gi-campaign-viewer',
    icon: (
      <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
      </svg>
    ),
    colors: {
      bg: 'bg-green-100 dark:bg-green-900/30',
      text: 'text-green-600 dark:text-green-400',
      border: 'border-gray-200 dark:border-gray-700'
    },
    displayCondition: (user) => {
      return user?.bi_modules?.allowed?.includes('GI_CAMPAIGNS_VIEWER') ||
             user?.bi_modules?.allowed?.includes('*') ||
             user?.issuperadmin;
    }
  },
  {
    id: 'GI_UNANSWERED_SURVEYS_VIEWER',
    name: 'Relance Form GI',
    description: 'Gérez et relancez les formulaires GI non remplis par vos équipes terrain.',
    path: '/gi-unanswered-surveys',
    icon: (
      <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    colors: {
      bg: 'bg-red-100 dark:bg-red-900/30',
      text: 'text-red-600 dark:text-red-400',
      border: 'border-gray-200 dark:border-gray-700'
    },
    displayCondition: (user) => {
      return user?.bi_modules?.allowed?.includes('GI_UNANSWERED_SURVEYS_VIEWER') ||
             user?.bi_modules?.allowed?.includes('*') ||
             user?.issuperadmin;
    }
  },
  {
    id: 'TELEMATIC_VIEWER',
    name: 'Données Télématiques',
    description: 'Suivez les temps de trajet et le kilométrage de vos équipes terrain.',
    path: '/telematic-viewer',
    icon: (
      <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
    colors: {
      bg: 'bg-indigo-200 dark:bg-indigo-800',
      text: 'text-indigo-700 dark:text-indigo-300',
      border: 'border-indigo-200 dark:border-indigo-700 rounded-lg'
    },
    isAdminOnly: true,
    specialStyle: 'bg-indigo-50 dark:bg-indigo-900/50 border-2',
    displayCondition: (user) => {
      return (user?.bi_modules?.allowed?.includes('TELEMATIC_VIEWER') ||
              user?.bi_modules?.allowed?.includes('*') ||
              user?.issuperadmin);
    }
  },
  {
    id: 'AI_QUERY_VIEWER',
    name: 'Requêtes IA',
    hide: true,
    description: 'Interrogez vos données avec l\'intelligence artificielle en langage naturel.',
    path: '/ai-query-viewer',
    icon: (
      <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
      </svg>
    ),
    colors: {
      bg: 'bg-yellow-200 dark:bg-yellow-800',
      text: 'text-yellow-700 dark:text-yellow-300',
      border: 'border-yellow-200 dark:border-yellow-700 rounded-lg'
    },
    isAdminOnly: true,
    specialStyle: 'bg-yellow-50 dark:bg-yellow-900/50 border-2',
    displayCondition: (user) => {
      return user?.issuperadmin;
    }
  },
  {
    id: 'GI_AI_REPORT_VIEWER',
    name: 'Rapports IA GI',
    description: 'Consultez les analyses IA des formulaires GI par client et campagnes.',
    path: '/gi-ai-report-viewer',
    icon: (
      <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
    colors: {
      bg: 'bg-teal-100 dark:bg-teal-900/30',
      text: 'text-teal-600 dark:text-teal-400',
      border: 'border-gray-200 dark:border-gray-700'
    },
    displayCondition: (user) => {
      return user?.bi_modules?.allowed?.includes('GI_AI_REPORT_VIEWER') ||
             user?.bi_modules?.allowed?.includes('*') ||
             user?.issuperadmin;
    }
  },
  {
    id: 'GI_PLANNING_VIEWER',
    name: 'Planning GI',
    description: 'Consultez le planning des campagnes et promoteurs par client.',
    path: '/gi-planning-viewer',
    icon: (
      <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
    colors: {
      bg: 'bg-orange-100 dark:bg-orange-900/30',
      text: 'text-orange-600 dark:text-orange-400',
      border: 'border-gray-200 dark:border-gray-700'
    },
    displayCondition: (user) => {
      return user?.bi_modules?.allowed?.includes('GI_PLANNING_VIEWER') ||
             user?.bi_modules?.allowed?.includes('*') ||
             user?.issuperadmin;
    }
  },
  {
    id: 'STATISTICS_VIEWER',
    name: 'Statistiques d\'usage',
    description: 'Consultez les statistiques d\'usage des outils.',
    path: '/statistics-viewer',
    icon: (
      <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    colors: {
      bg: 'bg-gray-100 dark:bg-gray-900/30',
      text: 'text-gray-600 dark:text-gray-400',
      border: 'border-gray-200 dark:border-gray-700'
    },
    isAdminOnly: true,
    displayCondition: (user) => {
      return user?.bi_modules?.allowed?.includes('STATISTICS_VIEWER') ||
             user?.issuperadmin;
    }
  },
  {
    id: 'GPS_VIEWER',
    name: 'GPS',
    description: 'Consultez les tickets d\'interventions.',
    path: '/gps-viewer',
    icon: (
      <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
      </svg>
    ),
    colors: {
      bg: 'bg-cyan-100 dark:bg-cyan-900/30',
      text: 'text-cyan-600 dark:text-cyan-400',
      border: 'border-gray-200 dark:border-gray-700'
    },
    displayCondition: (user) => {
      return user?.bi_modules?.allowed?.includes('GPS_VIEWER') ||
             user?.bi_modules?.allowed?.includes('*') ||
             user?.issuperadmin;
    }
  },
  {
    id: 'IP_VIEWER',
    name: 'Intervention Point Viewer',
    description: 'Visualisez l\'activité et les donées des points d\'intervention.',
    path: '/intervention-point-viewer',
    icon: (
      <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    colors: {
      bg: 'bg-pink-100 dark:bg-pink-900/30',
      text: 'text-pink-600 dark:text-pink-400',
      border: 'border-gray-200 dark:border-gray-700'
    },
    displayCondition: (user) => {
      return user?.bi_modules?.allowed?.includes('IP_VIEWER') ||
             user?.bi_modules?.allowed?.includes('*') ||
             user?.issuperadmin;
    }
  },
];

// Fonction utilitaire pour obtenir les modules visibles pour un utilisateur
export const getVisibleModules = (user) => {
  return MODULES_CONFIG.filter(module => module.displayCondition(user));
};

// Fonction utilitaire pour vérifier si un utilisateur a accès à un module
export const hasModuleAccess = (user, moduleId) => {
  const module = MODULES_CONFIG.find(m => m.id === moduleId);
  return module ? module.displayCondition(user) : false;
};

// Fonction pour obtenir les modules à afficher selon le type d'utilisateur
export const getModulesForHome = (user) => {
  if (user?.isadmin || user?.issuperadmin) {
    // Si admin : afficher tous les modules avec leur statut d'accès
    return MODULES_CONFIG.map(module => ({
      ...module,
      hasAccess: module.displayCondition(user)
    })).sort((a, b) => {
      // Trier : modules non-admin d'abord, puis modules admin
      if (!a.isAdminOnly && b.isAdminOnly) return -1;
      if (a.isAdminOnly && !b.isAdminOnly) return 1;

      // Dans chaque groupe, trier : modules accessibles d'abord, puis par ordre alphabétique
      if (a.hasAccess && !b.hasAccess) return -1;
      if (!a.hasAccess && b.hasAccess) return 1;
      return a.name.localeCompare(b.name);
    });
  } else {
    // Si utilisateur simple : afficher seulement les modules accessibles
    return MODULES_CONFIG
      .filter(module => module.displayCondition(user))
      .map(module => ({ ...module, hasAccess: true }))
      .sort((a, b) => {
        // Trier : modules non-admin d'abord, puis modules admin
        if (!a.isAdminOnly && b.isAdminOnly) return -1;
        if (a.isAdminOnly && !b.isAdminOnly) return 1;
        return a.name.localeCompare(b.name);
      });
  }
};